// @ts-nocheck

export type RoomGetWithTenants = typeof RoomGetWithTenants[keyof typeof RoomGetWithTenants];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomGetWithTenants = {
  true: 'true',
  false: 'false',
} as const;
